import { formatDecimal, type Decimal } from './decimal';

export type Currency = 'USD' | 'ARS';

export const CURRENCY_SYMBOL: Record<Currency, string> = { USD: 'US$', ARS: '$' };
export const CURRENCY_NAME: Record<Currency, string> = { USD: 'dólares', ARS: 'pesos' };

export function otherCurrency(c: Currency): Currency {
  return c === 'USD' ? 'ARS' : 'USD';
}

/** "US$ 3.986" / "$ 6.017.548,50". Whole amounts show no decimals unless `cents` is set. */
export function formatMoney(
  value: Decimal | null | undefined,
  currency: Currency,
  opts: { cents?: boolean; signed?: boolean } = {},
): string {
  if (value === null || value === undefined) return '—';
  const body = formatDecimal(value, { min: opts.cents ? 2 : 0, max: 2, signed: opts.signed });
  const negative = body.startsWith('−');
  return (negative ? '−' : '') + CURRENCY_SYMBOL[currency] + ' ' + body.replace(/^−/, '');
}
